import request from "@/utils/request";

let AdvanceApi = {
    /*商品列表*/
    goodsList(data, errorback) {
        return request._post("/merch/activity.advance/index", data, errorback);
    },
    /*添加商品*/
    getGoods(data, errorback) {
        return request._get("/merch/activity.advance/add", data, errorback);
    },
    /*添加商品*/
    addGoods(data, errorback) {
        return request._post("/merch/activity.advance/add", data, errorback);
    },
    /*预售商品详情*/
    detail(data, errorback) {
        return request._get("/merch/activity.advance/edit", data, errorback);
    },
    /*保存预售商品*/
    saveData(data, errorback) {
        return request._post("/merch/activity.advance/edit", data, errorback);
    },
    delGoods(data, errorback) {
        return request._post("/merch/activity.advance/delete", data, errorback);
    },
    /*获取设置*/
    getDiySkill(data, errorback) {
        return request._post("/merch/activity.advance/getDiyGoods", data, errorback);
    }
};
export default AdvanceApi;



// WEBPACK FOOTER //
// ./src/api/advance.js